import React, { createContext, useContext, useState, useEffect } from 'react';
import { auth, db } from './../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import i18n from "i18next";

const UserContext = createContext(null);

export const useUser = () => {
  return useContext(UserContext);
};

export const UserProvider = ({ children }) => {
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      if (firebaseUser) {
        const userDoc = await getDoc(doc(db, 'users', firebaseUser.uid));
        const newValue = { uid: firebaseUser.uid, ...userDoc.data() }
        setUserData(newValue);

        if (newValue["language"] === "se") {
          i18n.changeLanguage("se");
        } else {
          i18n.changeLanguage("da");
        }
      } else {
        setUserData(null);
      }
    });

    return () => unsubscribe();
  }, []);

  return (
    <UserContext.Provider value={{ userData, setUserData }}>
      {children}
    </UserContext.Provider>
  );
};
